import React, { useState } from 'react';

import { Flex } from '@chakra-ui/react';
import {
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContainer,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogOverlay,
  AlertDialogPortal,
  AlertDialogTitle,
  AlertDialogTrigger,
  Button,
} from '@mesh.ai/rabbit';
import { useToast } from 'components/hooks/useToast';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { sendClickedLaunchForAllEvent, sendLaunchedNewNavForOrgEvent } from 'constants/mixpanelHelper';

import { Checkbox } from 'uiToolkitV1/Checkbox';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { launchDeerApp } from '../services';

const LaunchDeerModal = () => {
  const [loading, setLoading] = useState(false);
  const [isSendEmail, setIsSendEmail] = useState(false);
  const toast = useToast();

  const onLaunchDeer = async () => {
    try {
      setLoading(true);
      await launchDeerApp({
        operationType: 'ENABLE_FOR_ORG',
        ...(isSendEmail && { sendEmail: isSendEmail }),
      });
      window.open('/', '_self');
    } catch (error) {
      toast({
        title: error?.message || 'Error while launching the new ux',
        status: 'error',
      });
      console.log('Error while launching the new ux : ', error);
    } finally {
      setLoading(false);
      sendLaunchedNewNavForOrgEvent({
        eventProperties: { source: checkNewNavEnabled() ? 'NewNav' : 'Rabbit', sentEmail: isSendEmail },
      });
    }
  };

  return (
    <AlertDialogContainer>
      <AlertDialogTrigger asChild>
        <Button
          variant={checkNewNavEnabled() ? 'text' : 'filled'}
          onClick={() =>
            sendClickedLaunchForAllEvent({ eventProperties: { source: checkNewNavEnabled() ? 'NewNav' : 'Rabbit' } })
          }
        >
          Launch for all
        </Button>
      </AlertDialogTrigger>
      <AlertDialogPortal>
        <AlertDialogOverlay />
        <AlertDialogContent>
          <AlertDialogTitle>
            Are you sure you want to switch to the new user experience for the whole organization?
          </AlertDialogTitle>

          <AlertDialogDescription>
            <Flex flexDir="column">
              <TextBodyMedium>
                By transitioning to the new experience, you won&apos;t be able to return to the old one.
              </TextBodyMedium>
              <Flex mt="20px">
                <Checkbox isChecked={isSendEmail} onChange={() => setIsSendEmail(!isSendEmail)} />
                <TextBodyMedium ml="8px">
                  Send email to all users about the change for the upgrade to new user experience.
                </TextBodyMedium>
              </Flex>
            </Flex>
          </AlertDialogDescription>
          <Flex borderRadius="8px" w="100%" px={4} py={3} background="#F5F7F9" justifyContent="space-between">
            <AlertDialogCancel asChild>
              <Button variant="text">Cancel</Button>
            </AlertDialogCancel>
            <AlertDialogAction asChild>
              <Button disabled={loading} onClick={onLaunchDeer}>
                Launch for all
              </Button>
            </AlertDialogAction>
          </Flex>
        </AlertDialogContent>
      </AlertDialogPortal>
    </AlertDialogContainer>
  );
};

export { LaunchDeerModal };
